module.exports = __webpack_public_path__ + "img/finish@2x.79c5d279.png";